import React from 'react';

import {TranslationService} from 'services';

const Context = React.createContext();

export class PasswordTranslationsProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordTranslations: null,
    };
  }

  componentDidMount() {
    this.fetchTranslations(this.props.locale);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.locale !== this.props.locale) {
      this.fetchTranslations(this.props.locale);
    }
  }

  fetchTranslations(locale) {
    TranslationService.getBundle('password', locale).then((data) => {
      this.setState({passwordTranslations: data});
    });
  }

  render() {
    return (
        <Context.Provider value={this.state}>
          {this.props.children}
        </Context.Provider>
    );
  }
}

export const PasswordTranslationsConsumer = Context.Consumer;